import { render, staticRenderFns } from "./LoadingEdc.vue?vue&type=template&id=7a552c96&scoped=true"
import script from "./LoadingEdc.vue?vue&type=script&lang=js"
export * from "./LoadingEdc.vue?vue&type=script&lang=js"
import style0 from "./LoadingEdc.vue?vue&type=style&index=0&id=7a552c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a552c96",
  null
  
)

export default component.exports